import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

/**
 *  Pop up showed when you have finished the game
 */
class AnswerQuestion extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.state = {
      answered: false,
      likeStatus: '',
    }
  }

  sound(sound) {
    const { addHowlSound } = this.props
    addHowlSound(sound)
  }
  componentDidMount() {
    const { prizeCoins } = this.props

    this.setState({ prizeCoins: prizeCoins })
  }

  componentWillUnmount() {
    const { clearResponses, currentQuestion } = this.props

    if (!currentQuestion) {
      clearResponses()
    }
  }

  answerQuestion(answer) {
    const { currentQuestion, answerQuestion } = this.props
    const { answered } = this.state

    if (!answered) {
      answerQuestion({ ...currentQuestion, selectedKey: answer.key })
      this.setState({ answered: true })
    }
  }

  renderAnswers(answer) {
    const { feedback } = this.props
    answer.text = answer.text || answer.title
    return (
      <div
        key={`answer-${answer.key}`}
        onClick={() => {
          this.answerQuestion(answer)
          this.sound('button_click')
        }}
        className={`mina--response ${this.getAnswerClass(answer, feedback)}`}
      >
        <label htmlFor={answer.id}>
          {answer.text && answer.text.length ? (
            <FormattedMessage id={answer.text} />
          ) : (
            <span>{answer.text}</span>
          )}
        </label>
      </div>
    )
  }

  getAnswerClass(answer, feedback) {
    if (feedback.answerId && answer.isCorrect) {
      return 'success'
    }
    if (answer.key !== feedback.answerId) {
      return ''
    }
    return feedback.correct ? 'success' : 'failed'
  }

  continueToMine() {
    const { endFlow, clearFeedBack, removeQuestion } = this.props

    clearFeedBack()
    endFlow()
    removeQuestion(null)
  }

  render() {
    const {
      currentQuestion,
      error,
      loading,
      addPopup,
      feedback,
      likeQuestion,
      counters: { wc: wildcard },
      hideWildCardButton,
      hideRefuseButton,
      isPenalized,
      intl,
    } = this.props
    const { answered, prizeCoins, likeStatus } = this.state

    const LoadingIcon = () => (
      <div className="loader min">
        <div className="loader--item">
          <span className="icon-hex-border" />
          <span className="icon-rocket-loading" />
        </div>
      </div>
    )

    const LikePanel = ({ currentQuestion, likeQuestion, likeStatus }) => {
      return this.props.isTutorial ? null : (
        <div className="box--likes">
          <span
            className={`icon-dislike ${
              likeStatus === 'dislike' ? 'failed' : likeStatus === 'like' ? 'disabled' : ''
            }`}
            onClick={() => {
              likeQuestion({ ...currentQuestion, like: 'dislike' })

              this.sound('wrong_answer')
            }}
          />
          <span
            className={`icon-like ${
              likeStatus === 'like' ? 'success' : likeStatus === 'dislike' ? 'disabled' : ''
            }`}
            onClick={() => {
              likeQuestion({ ...currentQuestion, like: 'like' })
              this.sound('right_answer')
            }}
          />
        </div>
      )
    }

    const WildCardButton = () => (
      <div
        onClick={() => {
          !answered && addPopup('wildcard_popup')
          this.sound('button_click')
        }}
        className="btn--blue"
      >
        <span className="icon-star" />
        <span>
          <FormattedMessage
            id={`${wildcard ? 'questions.use_wildcard_button' : 'questions.buy_wildcard_button'}`}
          />
        </span>
      </div>
    )

    const ContinueButton = () => (
      <div
        onClick={() => {
          this.continueToMine()
          this.sound('button_click')
        }}
        className="btn--shape shape--blue"
      >
        <div className="btn--shape__canvas">
          <FormattedMessage id="questions.continue" />
        </div>
      </div>
    )

    const RefuseButton = () => (
      <div
        onClick={() => {
          addPopup('refuse_question_alert')
          this.sound('button_click')
        }}
        className="btn--shape shape--orange"
      >
        <div className="btn--shape__canvas">
          <FormattedMessage id="questions.refuse" />
        </div>
      </div>
    )

    if (error && error == 'no_question') {
      return (
        <div className="mina--layer vertical--center fadeInLeft-animation">
          <div className="position--relative">
            <FormattedMessage id="questions.no_question" />
            <div className="mina--buttons">
              <div
                className="btn--shape shape--orange"
                onClick={() => {
                  this.continueToMine()
                  this.sound('button_click')
                }}
              >
                <div className="btn--shape__canvas">
                  <FormattedMessage id="questions.back" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }

    if (!currentQuestion) {
      return (
        <div className="mina--layer">
          <FormattedMessage id="questions.loading" />
        </div>
      )
    }

    const answers = currentQuestion.choices

    return (
      <React.Fragment>
        {feedback.answerId && (
          <LikePanel
            likeQuestion={(params) => {
              if (likeStatus === '') {
                likeQuestion(params)
                this.setState({ likeStatus: params.like })
              }
            }}
            currentQuestion={currentQuestion}
            likeStatus={likeStatus}
          />
        )}

        <div
          className={` mina--layer questions ${loading ? 'loading-question' : ''} growIn-animation`}
        >
          <div className="mina--type__questions">
            {currentQuestion.status == 'CERTIFIED' && !isPenalized && (
              <div className="certified">
                <span
                  className="icon-badge"
                  title={intl.formatMessage({ id: 'phase.tooltips.certified' })}
                ></span>
                <FormattedMessage id="questions.certified" />
              </div>
            )}
            {isPenalized && (
              <div className="penalized">
                <span
                  className="icon-penalizada"
                  title={intl.formatMessage({ id: 'phase.tooltips.penalized' })}
                ></span>
                <FormattedMessage id="questions.penalized" />
              </div>
            )}
          </div>
          <div className="mina--message active">
            <div>
              <span className="value">
                <span>
                  <FormattedMessage id={'questions.for'} />
                </span>
                {prizeCoins}
                <span className="icon-coin" />:
              </span>
              &nbsp;
              <FormattedMessage id={currentQuestion.question} />
            </div>
          </div>

          {answers.map((a) => this.renderAnswers(a))}

          <div className="mina--buttons">
            {currentQuestion.status != 'CERTIFIED' &&
              likeStatus !== 'like' &&
              !hideRefuseButton && <RefuseButton addPopup={addPopup} sound={this.sound} />}
            {!feedback.answerId ? (
              !hideWildCardButton &&
              !loading && <WildCardButton addPopup={addPopup} sound={this.sound} />
            ) : (
              <ContinueButton continueToMine={this.continueToMine} sound={this.sound} />
            )}
            {loading && <LoadingIcon />}
          </div>
        </div>
      </React.Fragment>
    )
  }
}

AnswerQuestion.propTypes = {
  answerQuestion: PropTypes.func,
  clearFeedBack: PropTypes.func,
  removeQuestion: PropTypes.func,
  clearResponses: PropTypes.func,
  endFlow: PropTypes.func,
  currentQuestion: PropTypes.object,
  error: PropTypes.bool,
  feedback: PropTypes.object,
  likeQuestion: PropTypes.func,
  loading: PropTypes.bool,
  isPenalized: PropTypes.bool,
  prizeCoins: PropTypes.number,
  addPopup: PropTypes.func,
  counters: PropTypes.object,
  addHowlSound: PropTypes.func,
  hideWildCardButton: PropTypes.bool,
  hideRefuseButton: PropTypes.bool,
  isTutorial: PropTypes.bool,
}

export default AnswerQuestion
